export default {
    listagem: {
        titulo_pagina: 'List of Methods',
        novo: 'Create New Method',
        habilitado: 'Able',
        desabilitado: 'Disabled',
        table: {
            empty: 'No Method Found',
            nome: 'Name',
            codigo: 'Code',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Method',
            editar: 'Edit Method'
        },
        fields: {
            codigo: {
                label: 'Code',
                description: 'Method Code'
            },
            nome: {
                label: 'Name',
                description: 'Method Name'
            },
            status: {
                label: 'Status',
                description: 'Method active or inactive status'
            },
            botao_salvar : 'Save Method'
        },
        create: {
            success: 'Method successfully created!',
            error: 'Error creating method!'
        },
        update: {
            success: 'Method successfully edited!',
            error: 'Error editing method!'
        }
    }
}
